// import { useParams } from "react-router-dom";
import { useState } from "react";

const BayDetails = () => {
  // const { id } = useParams();
  const [bay] = useState({
    id: 1,
    number: 102,
    accessId: null,
    location: {
      id: 1,
      location_name: "Warehouse A",
    },
    bayType: {
      id: 1,
      type_name: "Loading Dock",
    },
    shop: {
      id: 1,
      shop_name: "Shree Chandn Transport",
      owner: "Rajesh Kumar",
      contact: "+91 9876543210",
      address: "Plot No. 45, Industrial Area, Mumbai",
      services: ["Goods Transport", "Logistics", "Freight Services"],
    },
  });

  return (
    <div>
      <h1>Bay Details</h1>
      <h2>Bay Number: {bay.number}</h2>
    </div>
  );
};

export default BayDetails;
